import {
    Button,
    GenericSuspense,
    useCdnAssets,
    useRuntimeEnv,
    useTranslationRoute,
    useTranslations,
} from "@bsm/component";

import { useRedirectToApp } from "../hooks/useRedirectApp";
import { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import MainAuthLayout from "../components/layout/MainAuthLayout";
import PolygonSVG1 from "../components/PolygonSVG1";
import PolygonSVG2 from "../components/PolygonSVG2";
import "../css/auth-harea.css"

const UserAuthContainer = () => {
    const [GENERAL_CONDITION, PRIVACY_POLICY, HAREA_GENERIC] = useTranslations(i18n)
    const cdn = useCdnAssets();
    const redirectToApp = useRedirectToApp();
    const { runtimeEnv } = useRuntimeEnv();
    const tr = useTranslationRoute()
    useEffect(() => {
        if (runtimeEnv?.authenticated) {
            redirectToApp();
        }
    }, [runtimeEnv]);

    return (
        <>
            <div className=" relative">
                <div className="logo w-fit absolute top-4 left-4 max-sm:logo-sm">
                    <Link to={tr('')}>
                        <img src={`/assets/img/logo.png`} alt="harea_logo" className="h-10" />
                    </Link>
                </div>
                <div className="w-full h-full login-form flex justify-center gap-y-5 bg-white p-12 pt-40">
                    <div className="max-w-sm flex items-center justify-center">
                        <GenericSuspense>
                            <Outlet />
                        </GenericSuspense>
                    </div>
                </div>
            </div>
            <footer className="left max-sm:h-[6rem] sm:hidden">
                <div className="h-full flex flex-col justify-center items-start px-4 gap-3 text-[#ffffffaa] text-xs">
                    {HAREA_GENERIC}-1.0.15 © 2023
                </div>
            </footer>
        </>
    );
};

export default UserAuthContainer;

const i18n = ["std_general_condition", "std_privacy_policy", "Generic.de.harea"]